module.exports = __webpack_public_path__ + "media/18.03f2ebe4.mp3";